import { useRef, useEffect, useState } from "react";
import { formatLocalToRTSP, toIsoUtcString } from "../../utils/time";

const VideoDisplay = ({
  camera,
  isSelected,
  onSelect,
  stream,
  isLive = false,
  loading = false,
  handleToggleLive = () => {},
  videoRef,
}) => {
  // const videoRef = useRef(null);
  const [selectedDateTime, setSelectedDateTime] = useState("");

  useEffect(() => {
    if (videoRef.current && stream) {
      console.log("[INFO] Video stream recived!", stream);
      videoRef.current.srcObject = stream;
    }
  }, [stream]);

  const handleDateTimeChange = (e) => {
    const dateString = e.target.value;
    setSelectedDateTime(dateString);

    const localDate = new Date(dateString); // interpreted in local time
    const endDate = new Date(localDate.getTime() + 6 * 3600 * 1000);

    // Use local time for RTSP string format (not UTC ISO)
    const start = formatLocalToRTSP(localDate);
    const end = formatLocalToRTSP(endDate);

    handleToggleLive({
      isLive: false,
      startDate: start,
      endDate: end,
    });
  };

  const handleLiveClick = () => {
    const now = Math.floor(Date.now() / 1000);
    const start = toIsoUtcString(now - 12 * 3600);
    const end = toIsoUtcString(now);

    handleToggleLive({
      isLive: true,
      startDate: start,
      endDate: end,
    });
  };

  return (
    <div
      onClick={() => onSelect(camera)}
      style={{
        border: isSelected ? "1px solid dodgerblue" : "1px solid #ccc",
        padding: 10,
        cursor: "pointer",
        position: "relative",
      }}
    >
      <video ref={videoRef} autoPlay playsInline style={{ width: "100%", maxHeight: 600 }} muted />
      <div
        className="camera-label"
        style={{
          position: "absolute",
          bottom: 5,
          left: 5,
          background: "#fff",
          padding: "2px 5px",
          borderRadius: 4,
        }}
      >
        <strong>{camera?.camera_name || `Camera ${camera?._id}`}</strong>
      </div>

      <div className="control-bar">
        <input type="datetime-local" value={selectedDateTime} onChange={handleDateTimeChange} />
        <button className="live-button btn btn-danger" onClick={handleLiveClick}>
          {isLive ? "Exit Live" : "Live"}
        </button>
      </div>

      {loading && (
        <div className="loader-overlay">
          <div className="spinner-border text-light" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default VideoDisplay;
